export default {
  SET_SMS_CAMPAIGN_DETAILS(state, payload) {
    state[payload.key] = payload.value;
  },
  SET_SMS_TEMPLATE_DETAILS(state, payload) {
    state[payload.key] = payload.value;
  },
};
